/**
 * Enumeration of origins
 */
const Origins = Object.freeze({
    INVITE_LINK: 'WBI',
    NU_SKIN_DOT_COM: 'WBC'
});

module.exports = {
    Origins
};
